export default "__VITE_ASSET__6e7833fd__"